import React from 'react';

interface HtmlImgProps extends Omit<React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>, 'src' | 'alt'> {}

interface ImageProps extends HtmlImgProps {
  src: string;
  type: string;
  alt: string;
  fallback?: string;
  fallbackType?: string;
}

const Image: React.FC<ImageProps> = ({ src, type, alt, fallback = src, fallbackType = type, ...delegated }) => (
  <picture className="size-full">
    <source srcSet={src} type={type} />
    {fallback !== src && <source srcSet={fallback} type={fallbackType} />}
    <img src={src} alt={alt} {...delegated} />
  </picture>
);

export default Image;
